// ** React Imports
import { useRef, useEffect } from 'react'

// ** MUI Imports
import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

// ** Third Party Components
import PerfectScrollbarComponent from 'react-perfect-scrollbar'
import CustomAvatar from 'src/@core/components/mui/avatar'
import Image from 'next/image'

const PerfectScrollbar = styled(PerfectScrollbarComponent)(({ theme }) => ({
  padding: theme.spacing(5)
}))

const MessagesLog = props => {
  // ** Props
  const { data, hidden } = props


  // ** Ref
  const chatArea = useRef(null)

  // ** Scroll to chat bottom
  const scrollToBottom = () => {
    if (chatArea.current) {
      if (hidden) {
        // @ts-ignore
        chatArea.current.scrollTop = Number.MAX_SAFE_INTEGER
      } else {
        // @ts-ignore
        chatArea.current._container.scrollTop = Number.MAX_SAFE_INTEGER
      }
    }
  }

  useEffect(() => {
    if (data && data.chat && data.chat.length) {
      scrollToBottom()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  // ** Renders user chat
  const renderChats = () => {
    return data.chat.chat.map((item, index) => {
      const isSender = item.isFromMe
      const time = new Date(item.date).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })

      return (
        <Box
          key={index}
          sx={{
            display: 'flex',
            flexDirection: !item.isFromMe ? 'row' : 'row-reverse',
          }}
        >
          <div>
            <CustomAvatar
              skin='light'
              sx={{
                width: '2rem',
                height: '2rem',
                fontSize: '0.875rem',
                ml: isSender ? 4 : undefined,
                mr: !isSender ? 4 : undefined
              }}
              {...(data.chat.contact.avatar && !isSender
                ? {
                    src: data.chat.contact.avatar
                  }
                : {})}
              {...(isSender
                ? {
                    src: '/images/avatars/1.png'
                  }
                : {})}
            >
              {/* <Image src={data.chat.contact.avatar} width={30} height={30}></Image> */}
            </CustomAvatar>
          </div>

          <Box className='chat-body' sx={{ maxWidth: ['calc(100% - 5.75rem)', '75%', '65%'] ,position:'relative'}} >
            <Box key={index} sx={{ '&:not(:last-of-type)': { mb: 3.5 } }}>
            <div className=''>
                <Typography
                  sx={{
                    boxShadow: 1,
                    borderRadius: 1,
                    width: 'fit-content',
                    p: theme => theme.spacing(0, 2),
                    ml: isSender ? 'auto' : undefined,
                    borderTopLeftRadius: !isSender ? 0 : undefined,
                    borderTopRightRadius: isSender ? 0 : undefined,
                    color: isSender ? 'black' : 'text.primary',
                    backgroundColor: isSender ? '#D1FAE5' : '#F3F4F6',
                    mb:4.4,
                    mt:2
                  }}
                >
                  {typeof item.img === 'undefined' || item.img === '' ? (
                    <div className=' flex p-2 '>
                      <div>
                        <span className='font-semibold text-[0.8rem] text-black text-opacity-80 '>{item.text}</span>
                      </div>
                      <div className='absolute  bottom-0 right-0 '>
                        <h2 variant='caption' sx={{ color: 'text.disabled', }} >
                          <p className=' text-[#9CA3AF] text-[0.6rem] '>{time}</p>
                        </h2>
                      </div>
                    </div>
                  ) : (
                    <Image src={item.img} alt='Picture of the author' width={150} height={150} />
                  )}
                </Typography>
              </div>

            </Box>
          </Box>
        </Box>
      )
    })
  }

  const ScrollWrapper = ({ children }) => {
    if (hidden) {
      return (
        <Box ref={chatArea} sx={{ p: 5, height: '100%', overflowY: 'auto', overflowX: 'hidden' }}>
          {children}
        </Box>
      )
    } else {
      return (
        <PerfectScrollbar ref={chatArea} options={{ wheelPropagation: false }}>
          {children}
        </PerfectScrollbar>
      )
    }
  }

  return (
    <Box sx={{ height: 'calc(100% - 8.4375rem)' }} className='bg-viber'>
      <ScrollWrapper>{renderChats()}</ScrollWrapper>
    </Box>
  )
}

export default MessagesLog
